import React, { useState, useEffect } from 'react';
import Titlebar from "../components/Title.jsx";
import { MdDateRange, MdOutlineAccessTime, MdOutlineMap } from "react-icons/md";
import otilien from "../assets/uploads/ottilienwaldhuette.jpg";
import PollPage from './Poll.jsx';

function Grillfeier() {
    const calculateTimeLeft = () => {
        const targetDate = new Date('2025-07-12T16:00:00');
        const difference = targetDate.getTime() - new Date().getTime();
        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        } else {
            timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0, isTimeUp: true };
        }
        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearTimeout(timer);
    });

    return (
        <div>
            <Titlebar title="Einladung" />
            <div className='fw-bold text-dark font-meow text-center py-4'>Grillfeier 2025</div>
            <div className='row g-1 mx-3 justify-content-center align-items-center'>
                <div className='col-md-6'>
                    <div>
                        <div className='px-4 fw-semibold text-dark mb-3 text-center'>Liebe Raketen und ehemalige Raketen,</div>
                        <div className='px-4 text-justify'>Wir laden Euch ganz herzlich zur <b>Rakete-Grillfeier 2025</b> ein. Dem perfekten Anlass, um alte Bekannte wiederzusehen, gemeinsam zu lachen, zu spielen, zu feiern und natürlich zu schlemmen! Also packt Eure Grillsachen ein, bringt gute Laune mit und freut Euch auf einen Tag an der <b>Ottilien-Hütte</b>. Eure Liebsten dürfen natürlich auch mitkommen - <b>wir freuen uns auf Groß und Klein!</b></div>
                        <div className='px-4 text-center fw-semibold'></div>
                    </div>
                </div>
                <div className='col-md-6 justify-content-center px-5 pb-5 pt-4'>
                    <div className="p-4 border rounded-5 shadow-sm">
                        <div className='row p-2 font-meow fs-3 d-flex align-items-center justify-content-center'>
                            <div className='col-2 text-center'><MdDateRange size={30} className='text-danger' /></div>
                            <div className='col-8'><a className='text-decoration-none fw-semibold text-muted ms-3'>12. Juli 2025</a></div>
                        </div>
                        <div className='row p-2 font-meow fs-3 d-flex align-items-center justify-content-center'>
                            <div className='col-2 text-center'><MdOutlineAccessTime size={30} className='text-danger' /></div>
                            <div className='col-8 text-muted'><a className='text-decoration-none fw-semibold text-muted ms-3'>16:00 Uhr</a></div>
                        </div>
                        <div className='row p-2 font-meow fs-3 d-flex align-items-center justify-content-center'>
                            <div className='col-2 text-center'><MdOutlineMap size={30} className='text-danger' /></div>
                            <div className='col-8'><a href='https://www.forsthuetten-freiburg.de/de/huetten/show.php?id=4' className='text-decoration-none fw-semibold text-muted ms-3'>Otilienhütte</a></div>
                        </div>
                    </div>
                </div>
            </div>
                            
            <div className="rakete-font pb-5 px-4 mx-auto" style={{ maxWidth: "400px" }}>
                <div>
                    <div className="row g-2 text-center">
                        <div className="col-3">
                            <div className="p-3 bg-white border rounded shadow-sm">
                                <span className="fs-2 fw-bold text-dark">{String(timeLeft.days).padStart(2, '0')}</span>
                                <div className="d-block rakete-rot fs-8 fw-semibold">Tage</div>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="p-3 bg-white border rounded shadow-sm">
                                <span className="fs-2 fw-bold text-dark">{String(timeLeft.hours).padStart(2, '0')}</span>
                                <div className="d-block rakete-rot fs-8 fw-semibold">Stunden</div>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="p-3 bg-white border rounded shadow-sm">
                                <span className="fs-2 fw-bold text-dark">{String(timeLeft.minutes).padStart(2, '0')}</span>
                                <div className="d-block fs-8 rakete-rot fw-semibold">Minuten</div>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="p-3 bg-white border rounded shadow-sm">
                                <span className="fs-2 fw-bold text-dark">{String(timeLeft.seconds).padStart(2, '0')}</span>
                                <div className="d-block rakete-rot fs-8 fw-semibold">Sekunden</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row g-3 justify-content-center mx-4'>
                <div className='col-md-6 d-flex'>
                    <div className='rounded-3 border px-5 text-center shadow-sm h-100 w-100 d-flex flex-column mb-4 bg-white'>
                        <div className='text-center font-meow fs-1 mt-3 mb-2 fw-semibold rakete-rot'>Das stellen wir:</div>
                        <div className="flex-grow-1 fw-semibold">
                            <p className='m-1'>Grillplatz</p>
                            <p className='m-1'>Grillutensilien</p>
                            <p className='m-1'>Beilagen</p>
                            <p className='m-1'>Getränke</p>
                            <p className='m-1'>Zubehör (Pavillionzelt, Müllsäcke, Planen, usw.)</p>
                        </div>
                    </div>
                </div>
                <div className='col-md-6 d-flex'>
                    <div className='rounded-3 border px-5 text-center shadow-sm h-100 w-100 d-flex flex-column bg-white'>
                        <div className='text-center font-meow fs-1 mt-3 mb-2 fw-semibold rakete-rot'>Bitte mitbringen:</div>
                        <div className="flex-grow-1 fw-semibold">
                            <p className='m-1'>Grillgut (Steaks, Würstchen, Gemüse, usw.)</p>
                            <p className='m-1'>Becher und Tasse</p>
                            <p className='m-1'>Teller und Besteck</p>
                            <p className='m-1'>Salat oder Nachtisch*</p>
                            <p className='m-1'>Spiele*</p>
                            <p className='m-3 mb-4 mt-4 fs-7 fw-semibold'>*Welche Schlemmerei und welche Spiele ihr mitbringen könnt, erfahrt ihr noch :)</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='px-4 text-justify m-4 mt-5 mx-md-5 pt-md-4 px-md-3'>Damit wir besser planen können, bitten wir Euch um eine <b>Anmeldung bis zum 22. Juni 2025</b> über die Teilnahme-Umfrage <b>(siehe unten)</b>. Wie immer erwarten Euch Spiel, Spaß und Bewegung – bisher gab’s Seilhüpfen, Boule, Boccia, Frisbee, Kubb, Volleyball, Musik und vieles mehr. Wer mag, kann auch auf dem Dachboden der Hütte übernachten – bitte Schlafsack nicht vergessen! <b>Weite Infos zur Hütte findet ihr weiter unten.</b></div>
            <div className='font-meow fw-semibold fs-1 text-center'>Hinweiß für Mitlgieder</div>            
            <div className='px-4 text-justify m-3 mx-md-5 px-md-3'>Vor Beginn der Feier findet wie üblich unsere <b>jährliche Mitgliederversammlung (MV)</b> statt – ca. 90 Minuten, kurz und bündig, abhängig von Euren Themen. Die Einladung zur MV erhaltet Ihr separat per Mail.</div>
        <div className='px-4 mt-4 m-3 mx-md-5 px-md-3 text-center fw-bold'>Wir freuen uns riesig auf einen weiteren großartigen Tag mit Euch bei der Rakete-Grillfeier 2025! <p className='font-meow fw-semibold rakete-rot'>Eure Rakete</p></div>
        <PollPage id={'6827137ea1fb40dcfe66b461'} />
        <div className='my-5 rounded bg-rakete shadow-sm mx-md-5 mx-2'>
                <a href='https://www.forsthuetten-freiburg.de/de/huetten/show.php?id=4' className='text-decoration-none'><div className='font-meow fw-semibold pt-3 fs-1 text-white text-center'>Ottilienwaldhütte</div></a>
                <div className='row d-flex justify-content-center align-items-center'>                    
                    <div className='col-12 col-md-8 mb-3 mb-md-0 pt-3 px-4 ps-md-5 pb-md-5'>
                        <a href='https://www.forsthuetten-freiburg.de/de/huetten/show.php?id=4'>
                        <div className="ratio ratio-4x3 rounded-3 overflow-hidden shadow">
                            <img src={otilien}/>
                        </div>      
                        </a>            
                    </div>          
                    <div className='col-12 col-md-4 mb-3 mb-md-0'>
                        <div className="text-white text-center">
                            <h5 className="fw-semibold">Anfahrt</h5>
                            <div className="fs-7">Stationenweg</div>
                            <div className="fs-7">79104 Freiburg im Breisgau</div>
                            <a
                                href="https://www.google.com/maps/dir/?api=1&destination=Ottilienwaldhuette+Freiburg"
                                className="btn btn-light btn-sm m-3 text-decoration-none rakete-rot"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Route planen
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Grillfeier;
